import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sessionExpire : false
};

export const sessionValidation = createSlice({
  name: "sessionValidation",
  initialState,
  reducers: {
    showExpirePopup: (state, action) => {
      console.log("SJHPW",action.payload)
      state.sessionExpire = action.payload;
    },
  },
});

export const { showExpirePopup } = sessionValidation.actions;
export default sessionValidation.reducer;
